import React from "react"
import clsx from "clsx"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import ErrorIcon from "@material-ui/icons/Error"
import InfoIcon from "@material-ui/icons/Info"
import CloseIcon from "@material-ui/icons/Close"
import { amber } from "@material-ui/core/colors"
import IconButton from "@material-ui/core/IconButton"
import SnackbarContent from "@material-ui/core/SnackbarContent"
import WarningIcon from "@material-ui/icons/Warning"
import { makeStyles } from "@material-ui/core/styles"
import { FormattedMessage } from "react-intl"

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: "#64B5B5",
    display: "block",
  },
  error: {
    backgroundColor: "#E96F65",
    display: "block",
  },
  info: {
    backgroundColor: theme.palette.primary.main,
    display: "block",
  },
  warning: {
    backgroundColor: amber[700],
    display: "block",
  },
  icon: {
    fontSize: "20px",
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre-line",
    justifyContent: "space-between",
  },
}))

const SnackbarContentWrapper = React.forwardRef((props, ref) => {
  const classes = useStyles()
  const { message, onClose, variant } = props
  // eslint-disable-next-line security/detect-object-injection
  const Icon = variantIcon[variant]

  return (
    <SnackbarContent
      ref={ref}
      // eslint-disable-next-line security/detect-object-injection
      className={clsx(classes[variant], classes.snackbarStyle)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <span id="snackbar-message" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message === "Snackbar.Success" && (
              <FormattedMessage id="Snackbar.Success" />
            )}
            {message === "Snackbar.Error" && (
              <FormattedMessage id="Snackbar.Error" />
            )}
          </span>
          <span id="snackbar-button" className={classes.message}>
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
          </span>
        </span>
      }
    />
  )
})

export default SnackbarContentWrapper
